import React, { useState } from "react";
import "./icon_selector_styles.css";
import GoogleSymbols from "../../../utils/GoogleSymbols";
import Input from "../../FormComponents/Input";
import MaterialIcon from "../MaterialIcon"; // ✅ Import CSS

const IconSelector = ({ callbackFunction, customStyle = {} }) => {
  const [searchInput, setSearchInput] = useState("");

  const filteredIcons = searchInput
    ? GoogleSymbols.filter((icon) => icon.toLowerCase().includes(searchInput.toLowerCase()))
    : GoogleSymbols.slice(0, 50);

  return (
    <div className="icon_selector_container" style={customStyle}>
      <div className="icon_selector_search">
        <Input
          type="text"
          placeholder="Search icons"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
        />
      </div>

      {filteredIcons.length === 0 ? (
        <div className="icon_selector_empty">No icons found.</div>
      ) : (
        <div className="icon_grid">
          {filteredIcons.map((icon, index) => (
            <div key={index} title={icon.split(" ")[0]} className="icon_cell" onClick={() => callbackFunction(icon)}>
              <MaterialIcon
                name={icon.split(" ")[0]}
                style={{
                  fontSize: "24px",
                  width: "24px",
                  height: "24px",
                  color: "#333",
                  transition: "transform 0.2s"
                }}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default IconSelector;
